import { render, staticRenderFns } from "./higher-search-relationship.vue?vue&type=template&id=62252288&scoped=true&"
import script from "./higher-search-relationship.vue?vue&type=script&lang=js&"
export * from "./higher-search-relationship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62252288",
  null
  
)

export default component.exports